export class PlaybooksYtdValue {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    ytd: number;
}
